import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createWorkRecord,
  deleteWorkRecord,
  getWorkRecordDetail,
  getWorkRecordList,
  updateWorkRecord,
} from '../../api/constlink';
import {
  createWorkRecordAsync,
  CREATE_WORK_RECORD,
  deleteWorkRecordAsync,
  DELETE_WORK_RECORD,
  getWorkRecordListAsync,
  GET_WORK_RECORD_LIST,
  updateWorkRecordAsync,
  UPDATE_WORK_RECORD,
  getWorkRecordDetailAsync,
  GET_WORK_RECORD_DETAIL,
} from './actions';
import { WorkRecord } from './types';

function* getWorkRecordListSaga(
  action: ReturnType<typeof getWorkRecordListAsync.request>,
) {
  try {
    const workRecords: WorkRecord[] = yield call(
      getWorkRecordList,
      action.payload,
    );
    yield put(getWorkRecordListAsync.success(workRecords));
  } catch (e: any) {
    yield put(getWorkRecordListAsync.failure(e));
  }
}

function* createWorkRecordSaga(
  action: ReturnType<typeof createWorkRecordAsync.request>,
) {
  try {
    const workRecord: WorkRecord = yield call(createWorkRecord, action.payload);
    yield put(createWorkRecordAsync.success(workRecord));
  } catch (e: any) {
    yield put(createWorkRecordAsync.failure(e));
  }
}

function* getWorkRecordDetailSaga(
  action: ReturnType<typeof getWorkRecordDetailAsync.request>,
) {
  try {
    const workRecord: WorkRecord = yield call(
      getWorkRecordDetail,
      action.payload,
    );
    yield put(getWorkRecordDetailAsync.success(workRecord));
  } catch (e: any) {
    yield put(getWorkRecordDetailAsync.failure(e));
  }
}

function* updateWorkRecordSaga(
  action: ReturnType<typeof updateWorkRecordAsync.request>,
) {
  try {
    const workRecord: WorkRecord = yield call(updateWorkRecord, action.payload);
    yield put(updateWorkRecordAsync.success(workRecord));
  } catch (e: any) {
    yield put(updateWorkRecordAsync.failure(e));
  }
}

function* deleteWorkRecordSaga(
  action: ReturnType<typeof deleteWorkRecordAsync.request>,
) {
  try {
    const workRecordId: number = yield call(deleteWorkRecord, action.payload);
    yield put(deleteWorkRecordAsync.success(workRecordId));
  } catch (e: any) {
    yield put(deleteWorkRecordAsync.failure(e));
  }
}

export function* workRecordsSaga() {
  yield takeLatest(GET_WORK_RECORD_LIST, getWorkRecordListSaga);
  yield takeLatest(CREATE_WORK_RECORD, createWorkRecordSaga);
  yield takeLatest(GET_WORK_RECORD_DETAIL, getWorkRecordDetailSaga);
  yield takeLatest(UPDATE_WORK_RECORD, updateWorkRecordSaga);
  yield takeLatest(DELETE_WORK_RECORD, deleteWorkRecordSaga);
}
